export interface CTeStatus {
    label: string,
    value: string | null,
    refColor: string,
    code: string | null,
    active: boolean,
    visible: boolean,
}

/* espelha o CTeAuthStatus do backend. A cteTable acha o label com value.includes(status):
   AUTORIZADO precisa vir antes de AUTORIZADO_EPEC, senao um CT-e autorizado recebe o label do EPEC */
export const cteStatus: CTeStatus[] = [
    {
        label: 'Todos',
        value: null,
        refColor: '#000',
        code: null,
        active: true,
        visible: true
    },
    {
        label: 'Aguardando Envio',
        value: 'AGUARDANDO_ENVIO',
        refColor: '#5a72f8',
        code: '0',
        active: true,
        visible: true
    },
    {
        label: 'Processando Envio',
        value: 'PROCESSANDO_ENVIO',
        refColor: '#3149d1',
        code: '10',
        active: true,
        visible: true
    },
    {
        label: 'Erro no Envio',
        value: 'ERRO_ENVIO',
        refColor: '#f00d0d',
        code: '20',
        active: true,
        visible: true
    },
    {
        label: 'Enviado SEFAZ',
        value: 'ENVIADO_SEFAZ',
        refColor: '#ac24b1',
        code: '30',
        active: true,
        visible: true
    },
    {
        label: 'Erro SEFAZ',
        value: 'ERRO_SEFAZ',
        refColor: '#f00d0d',
        code: '40',
        active: true,
        visible: false
    },
    {
        label: 'Rejeitado SEFAZ',
        value: 'REJEITADO_SEFAZ',
        refColor: '#f00d0d',
        code: '50',
        active: true,
        visible: true
    },
    {
        label: 'Autorizado',
        value: 'AUTORIZADO',
        refColor: '#41c718',
        code: '100',
        active: true,
        visible: true
    },
    {
        label: 'Cancelado',
        value: 'CANCELADO',
        refColor: '#4d4d4d',
        code: '101',
        active: true,
        visible: true
    },
    {
        label: 'EPEC Autorizado',
        value: 'AUTORIZADO_EPEC',
        refColor: '#41c718',
        code: '124',
        active: true,
        visible: true
    },
];
